import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { menuItems } from '../hooks/constant';

export default function Tabbar() {
    const router = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);



    return (
        <div className="tabbar">
            <nav>
                <ul className="tabbar-nav">
                    {menuItems
                        .filter(item => item.isMobile)
                        .map((item, index) => (
                            <li className="tab-item" key={index}>
                                {item.external ? (
                                    <a href={item.url} target="_blank" rel="noreferrer" className={`${router.pathname === item.url ? 'active' : ''}`}>
                                        <span className="icon-wrap">
                                            {item.icon ? (
                                                <i className={item.icon}></i>
                                            ) : (
                                                item.image && <img src={item.image} alt={`${item.name}-logo`} width={30} height={30} />
                                            )}
                                        </span>
                                        <span className="link-name">{item.name}</span>
                                    </a>
                                ) : (
                                    <Link to={item.url} className={`${router.pathname === item.url ? 'active' : ''}`}>
                                        <span className="icon-wrap">
                                            {item.icon ? (
                                                <i className={item.icon}></i>
                                            ) : (
                                                item.image && <img src={item.image} alt={`${item.name}-logo`} width={30} height={30} />
                                            )}
                                        </span>
                                        <span className="link-name">{item.name}</span>
                                    </Link>
                                )}
                            </li>
                        ))}
                    <li className="tab-item">
                        <a href='#sec' className="tab-more" onClick={() => setMenuOpen(!menuOpen)}>
                            <span className="icon-wrap">
                                <i className="fa fa-light fa-bars"></i>
                            </span>
                            <span className="link-name">More</span>
                        </a>
                    </li>
                </ul>
            </nav>
            {menuOpen &&
                <>
                    <div class="close-tabbar-more"></div>
                    <nav class="tabbar-more">
                        {menuItems
                            .filter(item => !item.isMobile)
                            .map((item, index) => (
                                <li className="tab-item" key={index}>
                                    {item.external ? (
                                        <a href={item.url} target="_blank" rel="noreferrer" className={`${router.pathname === item.url ? 'active' : ''}`}>
                                            <span className="icon-wrap">
                                                {item.icon ? (
                                                    <i className={item.icon}></i>
                                                ) : (
                                                    item.image && <img src={item.image} alt={`${item.name}-logo`} width={30} height={30} />
                                                )}
                                            </span>
                                            <span className="link-name">{item.name}</span>
                                        </a>
                                    ) : (
                                        <Link to={item.url} className={`${router.pathname === item.url ? 'active' : ''}`}>
                                            <span className="icon-wrap">
                                                {item.icon ? (
                                                    <i className={item.icon}></i>
                                                ) : (
                                                    item.image && <img src={item.image} alt={`${item.name}-logo`} width={30} height={30} />
                                                )}
                                            </span>
                                            <span className="link-name">{item.name}</span>
                                        </Link>
                                    )}
                                </li>
                            ))}
                    </nav>
                </>
            }


        </div>
    )
}
